export const booleanInstructions = `### Boolean Keyword Overview

LobbyIQ offers users the ability to create Boolean keywords in addition to traditional keywords, to further enhance their ability to track mentions across government data sources.

The format of Boolean keywords follow four simple rules:

1. The keyword must start with \`r!\`
2. The only operators supported are \`AND\` and \`OR\`
3. Operators always support **2** arguments, with square brackets \`[]\` surrounding each argument
4. Operators use prefix notation
   * i.e. \`AND[][]\` and \`OR[][]\`

**Note for rule #3**

Just because each operator only supports 2 arguments, this doesn't mean you're limited in the total number of arguments you're able to use.

For example, 3 arguments can be represented either of these ways:
* \`AND[AND[][]][]\`
* \`AND[][AND[][]]\`

4 arguments can be represented any of these ways:
* \`AND[AND[][]][AND[][]]\`
* \`AND[AND[AND[][]][]][]\`
* \`AND[AND[][AND[][]]][]\`
* \`AND[][AND[AND[][]][]]\`
* \`AND[][AND[][AND[][]]]\`

And so on.

### Examples

Below are a few examples of a LobbyIQ Boolean expression, and their corresponding plain English description.

#### Example 1

- **Boolean:** \`r!AND[pharma][benefit manager]\`
- **Plain English:** "pharma" and "benefit manager"

#### Example 2

- **Boolean:** \`r!AND[cannabis][OR[OR[duty][excise]][tax]]\`
- **Plain English:** "cannabis" and one or more of ("duty", "excise", "tax")

#### Example 3

- **Boolean:** \`r!AND[OR[indigenous][reconciliation]][OR[OR[connectivity][broadband]][5g]]\`
- **Plain English:** One or more of ("indigenous", "reconciliation") and one or more of ("connectivity", "broadband", "5g")

#### Example 4

- **Boolean:** \`r!OR[AND[steel][tariff]][canadian steel]\`
- **Plain English:** Either "steel" and "tariff", or "canadian steel", or both.

#### Example 5

- **Boolean:** \`r!OR[AND[ training ][OR[OR[aerospace][ space ]][OR[aviation][airline]]]][OR[canadian aviation][aviation security]]\`
- **Plain English:** Either " training " and one or more of ("aerospace", " space ", "aviation", "airline"), or "canadian aviation", or "aviation security", or any combination of the 3.`; 